import { useTranslation } from 'react-i18next';
import { Card } from '@mui/material';
import STRING_KEYS from '../../language/keys';
import { UsersGroup2 } from '../../icons/user-group-2';
import { useTablePageParams } from '../../hooks/useTablePageParams';
import { useGetTalents } from '../../hooks/useTalents';
import ListPageContainer from '../../components/ListPageContainer';
import TalentsFilters from './TalentsFilters';
import { TALENTS_PAGE_FILTERS } from './talentsListPageFilters';
import { TalentsTable } from './TalentsTable';

export const TalentsListPage = (): JSX.Element => {
  const {
    activeFilters,
    onChangeFilter,
    currentPage,
    onPageChange,
    activeSort,
    onSortChange,
  } = useTablePageParams([
    TALENTS_PAGE_FILTERS.QUERY,
    TALENTS_PAGE_FILTERS.COMPANY,
  ]);

  const { t: translate } = useTranslation();
  const { error, data, isLoading } = useGetTalents(
    activeFilters,
    currentPage,
    activeSort,
  );

  const handleChangePage = (newPageNumber: number): void => {
    onPageChange(newPageNumber);
  };

  return (
    <ListPageContainer
      title={ {
        text: translate(STRING_KEYS.TALENTS_PAGE_TITLE),
        icon: <UsersGroup2 />,
      } }
    >
      <Card>
        <TalentsFilters
          activeFilters={ activeFilters }
          onChangeFilter={ onChangeFilter }
        />
        <TalentsTable
          page={ currentPage - 1 }
          talentsData={ data }
          error={ error }
          isLoading={ isLoading }
          onPageChnage={ handleChangePage }
          activeSort={ activeSort }
          onSortClick={ onSortChange }
        />
      </Card>
    </ListPageContainer>
  );
};
